export default function About() {
  const values = [
    { icon: "ri-eye-line", title: "真实客观", desc: "评分与评测独立公正，不随热度左右，只为值得的作品发声。" },
    { icon: "ri-article-line", title: "深度内容", desc: "拒绝标题党，用扎实的解析与真诚的文字呈现作品价值。" },
    { icon: "ri-hand-heart-line", title: "守护创作者", desc: "坚持正版导向，引导观众支持作品，让好作品持续诞生。" },
    { icon: "ri-team-line", title: "开放共赏", desc: "欢迎每一位爱好者投稿与讨论，一起把热爱分享给更多人。" },
  ];

  return (
    <section id="about" className="relative w-full bg-background-900/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 md:gap-12">
          <div>
            <span className="text-sm tracking-widest text-accent-400">ABOUT US</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-50 md:text-4xl">关于漫镜</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-300">
              漫镜 ACG 诞生于一群资深动漫爱好者的共同理想——为所有追番的人打造一个
              「看得懂、找得快、追得顺」的资讯灯塔。我们相信，好的作品值得被更多人看见，
              也值得被认真对待。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              从新番情报到高分榜单，从深度评测到主题分类，我们坚持用真实、客观、有温度的内容，
              陪伴每一位动漫爱好者在海量作品中找到属于自己的那束光。我们不提供任何盗版下载，
              只做资讯与正版内容导航，守护每一位创作者的心血。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-lg border border-background-800/70 bg-background-900 p-5 transition-colors hover:border-primary-500/50"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500/15 text-primary-300">
                  <i className={`${v.icon} text-lg`} />
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-50">{v.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-400">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}